import { Box, IconButton, useBreakpointValue ,Image} from '@chakra-ui/react';
import "slick-carousel/slick/slick.css";
 import "slick-carousel/slick/slick-theme.css";
import { useState } from 'react';
// Here we have used react-icons package for the icons
import { BiLeftArrowAlt, BiRightArrowAlt } from 'react-icons/bi';
// And react-slick as our Carousel Lib
import Slider from 'react-slick';

// Settings for the slider
const settings = {
  dots: true,
  arrows: false,
  fade: true,
  infinite: true,
  autoplay: true,
  speed: 500,
  autoplaySpeed: 5000,
  slidesToShow: 1,
  slidesToScroll: 1,
};

export default function SlideShow() {
  // As we have used custom buttons, we need a reference variable to
  // change the state
  const [slider, setSlider] = useState<Slider | null>(null);

  // These are the breakpoints which changes the position of the
  // buttons as the screen size changes
  const top = useBreakpointValue({ base: '90%', md: '50%' });
  const side = useBreakpointValue({ base: '30%', md: '10px' });

  // These are the images used in the slide
  const cards = [
    'https://firebasestorage.googleapis.com/v0/b/proshippingapi.appspot.com/o/0.png?alt=media&token=f8fddaf5-265c-4be1-83e0-a9956f798140',
    'https://firebasestorage.googleapis.com/v0/b/proshippingapi.appspot.com/o/1.jpg?alt=media&token=bee07214-7ba2-4af4-bce3-2a99316ab0fe',
    'https://firebasestorage.googleapis.com/v0/b/proshippingapi.appspot.com/o/2.jpg?alt=media&token=2a88d701-031d-4d39-b9dc-01462f006a68',
    'https://firebasestorage.googleapis.com/v0/b/proshippingapi.appspot.com/o/3.jpg?alt=media&token=e752f33f-7501-482c-a297-6e004afe9273',
    'https://firebasestorage.googleapis.com/v0/b/proshippingapi.appspot.com/o/4.jpg?alt=media&token=30f04234-ce1c-4afc-b5a7-acbec24dc7d4'
  ];

  return (
    <Box
      position={'relative'}
      height={'full'}
      width={'full'}
      overflow={'hidden'}>
      {/* CSS files for react-slick */}
    
      {/* Left Icon */}
      <IconButton
        aria-label="left-arrow"
        colorScheme="messenger"
        borderRadius="full"
        position="absolute"
        left={side}
        top={top}
        transform={'translate(0%, -50%)'}
        zIndex={2}
        onClick={() => slider?.slickPrev()}>
        <BiLeftArrowAlt />
      </IconButton>
      {/* Right Icon */}
      <IconButton
        aria-label="right-arrow"
        colorScheme="messenger"
        borderRadius="full"
        position="absolute"
        right={side}
        top={top}
        transform={'translate(0%, -50%)'}
        zIndex={2}
        onClick={() => slider?.slickNext()}>
        <BiRightArrowAlt />
      </IconButton>
      {/* Slider */}
      <Slider {...settings} ref={(slider) => setSlider(slider)}>
        {cards.map((url, index) => (
        <Box key={index} background={'red'} justifyContent={'center'}>
            <Image          
            objectFit={'cover'}
            src={url}
            />
        </Box>
        ))}
      </Slider>
    </Box>
  );
}
